import { useMemo, useState } from 'react';
import { Editor, JTinyMCEExtensionsBuilders } from 'jamespot-react-components';
import { useIntl } from 'react-intl';

export const useMarkdownModal = (): {
    open: boolean;
    onInsert: (v: string) => void;
    close: () => void;
    ext: ReturnType<typeof JTinyMCEExtensionsBuilders.markdown>;
    isActive?: boolean;
} => {
    const intl = useIntl();
    const [open, setOpen] = useState(false);
    const [editor, setEditor] = useState<Editor>();
    const ext = useMemo(
        () =>
            JTinyMCEExtensionsBuilders.markdown((ed) => {
                setEditor(ed);
                setOpen(true);
            }, intl),
        [intl],
    );
    return {
        open,
        onInsert: (v: string) => {
            editor?.execCommand('InsertHTML', false, v);
        },
        close: () => setOpen(false),
        ext,
        isActive: true,
    };
};
